import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import emailjs from 'emailjs-com';
import WhatsAppIcon from './WhatsAppIcon';

const styles = `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600&family=DM+Mono:wght@400;500&display=swap');

  :root {
    --bg:          #0a1628;
    --bg-card:     #0f1e35;
    --bg-card-h:   #132440;
    --teal:        #00adb5;
    --teal-dim:    rgba(0,173,181,0.12);
    --teal-border: rgba(0,173,181,0.22);
    --accent:      #ff5722;
    --accent-h:    #e64a19;
    --white:       #f0f4f8;
    --muted:       rgba(240,244,248,0.45);
    --transition:  0.22s cubic-bezier(0.4,0,0.2,1);
  }

  * { box-sizing: border-box; margin: 0; padding: 0; }

  .vedo-contato {
    min-height: calc(100vh - 100px);
    background:
  radial-gradient(
    circle at 20% 10%,
    rgba(0, 173, 181, 0.08),
    transparent 40%
  ),
  radial-gradient(
    circle at 80% 90%,
    rgba(0, 173, 181, 0.05),
    transparent 50%
  ),
  linear-gradient(
    160deg,
    #0e223f 0%,
    #0b1b30 45%,
    #081220 100%
  );
    display: flex;
    align-items: flex-start;
    justify-content: center;
    padding: 40px 20px 60px;
    font-family: 'DM Sans', sans-serif;
  }

  .vedo-contato__card {
    background: var(--bg-card);
    border: 1px solid var(--teal-border);
    border-radius: 14px;
    padding: 36px 32px 32px;
    width: 100%;
    max-width: 480px;
    box-shadow: 0 16px 48px rgba(0,0,0,0.35);
    animation: cardIn 0.35s cubic-bezier(0.4,0,0.2,1) both;
  }
  @keyframes cardIn {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  @media (max-width: 520px) {
    .vedo-contato__card { padding: 28px 20px 24px; }
  }

  /* ── Topo ── */
  .vedo-contato__top {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .vedo-contato__status {
    display: flex;
    align-items: center;
    gap: 7px;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.14em;
    text-transform: uppercase;
    color: #4caf92;
  }
  .vedo-contato__status-dot {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #4caf92;
    box-shadow: 0 0 0 0 rgba(76,175,146,0.6);
    animation: pulse 2s ease-in-out infinite;
  }
  @keyframes pulse {
    0%  { box-shadow: 0 0 0 0 rgba(76,175,146,0.5); }
    70% { box-shadow: 0 0 0 7px rgba(76,175,146,0); }
    100%{ box-shadow: 0 0 0 0 rgba(76,175,146,0); }
  }

  /* ── Título do domínio ── */
  .vedo-contato__domain-wrap {
    margin-bottom: 28px;
    padding-bottom: 24px;
    border-bottom: 1px solid rgba(255,255,255,0.06);
  }

  .vedo-contato__label {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--teal);
    margin-bottom: 6px;
  }

  .vedo-contato__domain {
    font-family: 'DM Mono', monospace;
    font-size: 22px;
    font-weight: 500;
    color: var(--white);
    letter-spacing: 0.01em;
    word-break: break-all;
    line-height: 1.3;
  }

  .vedo-contato__domain--vender {
    font-family: 'DM Sans', sans-serif;
    font-size: 20px;
    font-weight: 600;
    color: var(--white);
  }

  .vedo-contato__domain-sub {
    font-size: 13px;
    color: var(--muted);
    margin-top: 6px;
    line-height: 1.5;
  }

  /* ── Formulário ── */
  .vedo-contato__form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .vedo-contato__field {
    display: flex;
    flex-direction: column;
    gap: 6px;
  }

  .vedo-contato__field label {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: var(--muted);
  }

  .vedo-contato__input,
  .vedo-contato__textarea {
    background: var(--teal-dim);
    border: 1px solid var(--teal-border);
    border-radius: 7px;
    padding: 11px 14px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    color: var(--white);
    outline: none;
    transition: border-color var(--transition), background var(--transition);
    width: 100%;
  }

  .vedo-contato__input::placeholder,
  .vedo-contato__textarea::placeholder { color: var(--muted); }

  .vedo-contato__input:focus,
  .vedo-contato__textarea:focus {
    border-color: var(--teal);
    background: rgba(0,173,181,0.16);
  }

  .vedo-contato__textarea {
    resize: vertical;
    min-height: 110px;
    line-height: 1.55;
  }

  /* ── Botão enviar ── */
  .vedo-contato__submit {
    width: 100%;
    background: var(--accent);
    border: none;
    border-radius: 7px;
    color: #fff;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    font-weight: 600;
    padding: 13px;
    cursor: pointer;
    letter-spacing: 0.04em;
    box-shadow: 0 3px 14px rgba(255,87,34,0.35);
    transition: background var(--transition), box-shadow var(--transition), transform var(--transition);
    margin-top: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
  }
  .vedo-contato__submit:hover:not(:disabled) {
    background: var(--accent-h);
    box-shadow: 0 5px 20px rgba(255,87,34,0.5);
    transform: translateY(-1px);
  }
  .vedo-contato__submit:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none;
  }

  /* spinner no botão */
  .vedo-contato__spinner {
    width: 15px;
    height: 15px;
    border-radius: 50%;
    border: 2px solid rgba(255,255,255,0.3);
    border-top-color: #fff;
    animation: spin 0.7s linear infinite;
  }
  @keyframes spin { to { transform: rotate(360deg); } }

  /* ── Feedback ── */
  .vedo-contato__feedback {
    margin-top: 16px;
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13.5px;
    line-height: 1.5;
    animation: cardIn 0.25s ease both;
  }
  .vedo-contato__feedback--success {
    background: rgba(76,175,146,0.12);
    border: 1px solid rgba(76,175,146,0.3);
    color: #4caf92;
  }
  .vedo-contato__feedback--error {
    background: rgba(255,87,34,0.1);
    border: 1px solid rgba(255,87,34,0.3);
    color: #ff7043;
  }

  /* ── Indisponível ── */
  .vedo-contato__unavailable {
    text-align: center;
    padding: 24px 0 8px;
  }
  .vedo-contato__unavailable-icon {
    font-size: 32px;
    margin-bottom: 12px;
    opacity: 0.4;
  }
  .vedo-contato__unavailable-text {
    font-size: 14px;
    color: var(--muted);
    line-height: 1.6;
  }
`;

function Contato() {
  const { dominioNome } = useParams();

  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [successMessage, setSuccessMessage]   = useState('');
  const [errorMessage, setErrorMessage]       = useState('');
  const [sending, setSending]                 = useState(false);
  const [queroVender, setQueroVender]         = useState(false);
  const [indisponivel, setIndisponivel]       = useState(false);

  useEffect(() => {
    if (dominioNome === 'QueroVender') {
      setQueroVender(true);
      setIndisponivel(false);
      setFormData({ name: '', email: '', message: '' });
    } else {
      setQueroVender(false);
      setFormData((prev) => ({
        ...prev,
        message: dominioNome && dominioNome !== 'Contato'
          ? `Olá, tenho interesse no domínio ${dominioNome}.`
          : '',
      }));
    }
  }, [dominioNome]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSending(true);
    emailjs
      .sendForm('enviaremailvedo', 'template_venaxcj', e.target, 'CtqNjPWscFl08NDjp')
      .then(
        () => {
          setSuccessMessage('Mensagem enviada! Retornaremos em breve.');
          setErrorMessage('');
          setFormData({ name: '', email: '', message: '' });
        },
        () => {
          setErrorMessage('Erro ao enviar. Por favor, tente novamente.');
          setSuccessMessage('');
        }
      )
      .finally(() => setSending(false));
  };

  const isVender  = queroVender;
  const textareaPlaceholder = isVender
    ? 'Liste o nome e o preço dos domínios e nós retornaremos o contato o quanto antes.'
    : 'Digite sua mensagem aqui';

  return (
    <>
      <style>{styles}</style>

      <div className="vedo-contato">
        <div className="vedo-contato__card">

          {/* ── Topo: status + WhatsApp ── */}
          <div className="vedo-contato__top">
            <div className="vedo-contato__status">
              <div className="vedo-contato__status-dot" />
              Online
            </div>
            <WhatsAppIcon />
          </div>

          {/* ── Título ── */}
          <div className="vedo-contato__domain-wrap">
            {isVender ? (
              <>
                <p className="vedo-contato__label">Proposta</p>
                <div className="vedo-contato__domain--vender">Quero Vender meu Domínio</div>
                <p className="vedo-contato__domain-sub">
                  Informe os domínios que deseja vender e entraremos em contato.
                </p>
              </>
            ) : indisponivel ? (
              <>
                <p className="vedo-contato__label">Domínio</p>
                <div className="vedo-contato__domain">{dominioNome?.toLowerCase()}</div>
                <div className="vedo-contato__unavailable">
                  <div className="vedo-contato__unavailable-icon">🔒</div>
                  <p className="vedo-contato__unavailable-text">
                    Este domínio não está disponível para venda no momento.
                  </p>
                </div>
              </>
            ) : (
              <>
                <p className="vedo-contato__label">Domínio de interesse</p>
                <div className="vedo-contato__domain">{dominioNome?.toLowerCase()}</div>
                <p className="vedo-contato__domain-sub">
                  Preencha o formulário e entraremos em contato.
                </p>
              </>
            )}
          </div>

          {/* ── Formulário (oculto se indisponível) ── */}
          {!indisponivel && (
            <form className="vedo-contato__form" onSubmit={handleSubmit}>

              <div className="vedo-contato__field">
                <label htmlFor="name">Nome</label>
                <input
                  className="vedo-contato__input"
                  id="name"
                  type="text"
                  name="name"
                  placeholder="Seu nome completo"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="vedo-contato__field">
                <label htmlFor="email">E-mail</label>
                <input
                  className="vedo-contato__input"
                  id="email"
                  type="email"
                  name="email"
                  placeholder="seu@email.com"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="vedo-contato__field">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  className="vedo-contato__textarea"
                  id="message"
                  name="message"
                  rows="4"
                  placeholder={textareaPlaceholder}
                  value={formData.message}
                  onChange={handleChange}
                  required
                />
              </div>

              <button
                type="submit"
                className="vedo-contato__submit"
                disabled={sending}
              >
                {sending ? (
                  <>
                    <div className="vedo-contato__spinner" />
                    Enviando...
                  </>
                ) : (
                  'Enviar mensagem'
                )}
              </button>

            </form>
          )}

          {/* ── Feedback ── */}
          {successMessage && (
            <div className="vedo-contato__feedback vedo-contato__feedback--success">
              ✓ {successMessage}
            </div>
          )}
          {errorMessage && (
            <div className="vedo-contato__feedback vedo-contato__feedback--error">
              ✕ {errorMessage}
            </div>
          )}

        </div>
      </div>
    </>
  );
}

export default Contato;